import React, { useEffect } from "react";
import config from "../config";
import { CssBaseline } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ConfirmDialog } from "primereact/confirmdialog";

import "./eventComponent/EventTabs/EventTabs.css";
import { homePagePath } from "../constant";
import Navbar from "../redesign/components/Navbar";
import Footer from "../redesign/components/Footer";

export const ChildrensPrivacy = () => {
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  const backtoHome = () => {
    navigate(isLoggedIn ? "/dashboard" : homePagePath);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <CssBaseline />
      <Navbar />

      <div className={`main-container ${!isLoggedIn ? "no-auth" : ""}`}>
        <div className="event-service-head-inner-policy">
          <div>
            <button
              className="back-to-services-btn"
              onClick={backtoHome}
            >
              <i className='pi pi-arrow-left'></i> Back to Dashboard
            </button>
          </div>
        </div>
        <div className="center-heading">
          <h1>Children's Privacy</h1>
        </div>
        <div className="frontend-container">
          <div className="event-form-inner">
            <div className="event-form-body alter full">
              <div className="event-form-content">

                <p>
                  Our Service does not address anyone under the age of 13. We do not knowingly collect
                  personally identifiable information from anyone under the age of 13. If You are a
                  parent or guardian and You are aware that Your child has provided Us with Personal
                  Data, please contact Us. If We become aware that We have collected Personal Data from
                  anyone under the age of 13 without verification of parental consent, We take steps to
                  remove that information from Our servers.
                </p>
                <p>
                  If We need to rely on consent as a legal basis for processing Your information and
                  Your country requires consent from a parent, We may require Your parent's consent
                  before We collect and use that information.
                </p>

                <div className="terms_conditions-info-container">
                  <p>
                    Registered Office: {config.contactAddress.replace(/\n/g, ', ')}
                  </p>
                  <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    padding: "0 20px"
                  }}>
                    <p style={{ margin: 0 }}>Email: {(config.contactInfo[(process.env.REACT_APP_API_REGION || 'INDIA').toUpperCase().startsWith('IN') ? 'india' : 'usa'].email)}</p>
                    {(config.contactInfo[(process.env.REACT_APP_API_REGION || 'INDIA').toUpperCase().startsWith('IN') ? 'india' : 'usa'].phone) && <p style={{ margin: 0 }}>Phone: {(config.contactInfo[(process.env.REACT_APP_API_REGION || 'INDIA').toUpperCase().startsWith('IN') ? 'india' : 'usa'].phone)}</p>}
                    <p style={{ margin: 0 }}>Website: {config.websiteUrl}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <ConfirmDialog />
    </div>
  );
};

export default ChildrensPrivacy;
